/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import {
  Modal,
  Col,
  Typography,
  Form,
  Row,
  Input,
  Button,
  message,
  Spin,
  Table,
  Tooltip,
  DatePicker,
  notification,
  Select,
  InputNumber,
  Upload,
} from 'antd';
import {
  ImportOutlined,
  EditOutlined,
  DeleteOutlined,
  UploadOutlined,
  CloudUploadOutlined,
  CloseOutlined,
  DownloadOutlined,
  PlusOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { Button as CrcButton } from '@crc-evans/ui-components';
import {
  fetchEmployeesList,
  addEmployee,
  updateEmployee,
  uploadBulkEmployeeList,
  deleteEmployee,
} from '../redux/admin/employees/action';
import * as XLSX from 'xlsx';
import axios from 'axios';
import moment from 'moment';
import get from 'lodash/get';
const { Title, Text } = Typography;
import { connect } from 'react-redux';
// import CommonAGGridTable from './AG Grid/CommonAGGridTable';

const convertExcelDate = (serial) => {
  if (typeof serial === 'number') {
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);

    const fractional_day = serial - Math.floor(serial);
    const total_seconds = Math.floor(86400 * fractional_day);

    const seconds = total_seconds % 60;
    const hours = Math.floor(total_seconds / 3600);
    const minutes = Math.floor(total_seconds / 60) % 60;

    return new Date(
      Date.UTC(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      )
    );
  }
  return null;
};

const AdminEmployees = (props) => {
  const {
    onFetchEmployeesList,
    onAddEmployee,
    onUpdateEmployee,
    onUploadBulkEmployeeList,
    onDeleteEmployee,
    employeeList,
    isEmployeeListLoading,
  } = props;

  const [fileModalVisible, setFileModalVisible] = useState(false);
  const [formModalVisible, setFormModalVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [ratesHeader, setRatesHeader] = useState([
    'CoCd',
    'PersNo',
    'Cost Ctr',
    'Name of Employee or Applicant',
    'Start Date',
    'End Date',
  ]);
  const [uploadedData, setUploadedData] = useState([...employeeList]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchInput, setSearchInput] = useState('');

  const [isEdit, setIsEdit] = useState(false);
  const [employeeId, setEmployeeId] = useState('');
  const [userForm] = Form.useForm();
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [columnDefs, setColumnDefs] = useState([]);
  const [layoutSave, setLayoutSave] = useState(false);
  const [layoutLoad, setLayoutLoad] = useState(false);
  const [isPivotMode, setIsPivotMode] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(0);
  //Table column
  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      key: 'sno',
      width: 80,
      render: (text, record, index) => index + 1,
    },
    {
      title: 'COCD',
      dataIndex: 'coCd',
      key: 'coCd',
      width: 120,
      render: (data) => truncateTableData(data),
    },
    {
      title: 'PERSNO',
      dataIndex: 'personNumber',
      key: 'personNumber',
      width: 150,
      render: (data) => truncateTableData(data),
    },
    {
      title: 'COST CTR',
      dataIndex: 'costCenter',
      key: 'costCenter',
      width: 150,
      render: (data) => truncateTableData(data),
    },
    {
      title: 'NAME OF EMPLOYEE',
      dataIndex: 'employeeName',
      key: 'employeeName',
      render: (data) => truncateTableData(data),
    },
    {
      title: 'START DATE',
      dataIndex: 'startDate',
      key: 'startDate',
      width: 160,
      render: (text) => (text ? moment(text).format('DD-MMM-YYYY') : '-'),
    },
    {
      title: 'END DATE',
      dataIndex: 'endDate',
      key: 'endDate',
      width: 160,
      render: (text) => (text ? moment(text).format('DD-MMM-YYYY') : '-'),
    },
    {
      title: 'ACTIONS',
      dataIndex: 'actions',
      key: 'actions',
      width: 120,
      align: 'center',
      render: (text, record) => (
        <div className="heat-profile-actions-cell">
          <Tooltip title="Edit">
            <EditOutlined
              className="txtIcon"
              style={{ fontSize: '18px', cursor: 'pointer', marginRight: '16px' }}
              onClick={() => showAddEditListModal(record, true)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteOutlined
              className="txtIcon"
              style={{ fontSize: '18px', cursor: 'pointer' }}
              onClick={() => handleDeletion(record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const generateColumns = async () => {
    const columnDefs = [
      {
        headerName: 'S.No',
        field: 'sno',
        maxWidth: 150,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'center' },
        valueGetter: (params) => params.data.sno,
        suppressMovable: true,
        lockPosition: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },

      {
        headerName: 'CoCd',
        field: 'coCd',
        width: 120,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
        cellRenderer: (params) => truncateTableData(params.value),
      },
      {
        headerName: 'PersNo',
        field: 'personNumber',
        width: 120,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
        cellRenderer: (params) => truncateTableData(params.value),
      },
      {
        headerName: 'Cost Ctr',
        field: 'costCenter',
        width: 120,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Name of Employee',
        field: 'employeeName',
        width: 200,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
        cellRenderer: (params) => truncateTableData(params.value),
      },
      {
        headerName: 'Start Date',
        field: 'startDate',
        width: 150,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: ['equals', 'greaterThan', 'lessThan'],
          buttons: ['reset'],
        },
        cellRenderer: (params) => {
          if (!params.value) return '-';
          const date = moment(params.value);
          return date.isValid() ? date.format('DD-MM-YYYY') : '-';
        },
      },
      {
        headerName: 'End Date',
        field: 'endDate',
        width: 150,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: ['equals', 'greaterThan', 'lessThan'],
          buttons: ['reset'],
        },
        cellRenderer: (params) => {
          if (!params.value) return '-';
          const date = moment(params.value);
          return date.isValid() ? date.format('DD-MM-YYYY') : '-';
        },
      },
      {
        headerName: 'Actions',
        field: 'actions',
        width: 120,
        cellStyle: { textAlign: 'center' },
        suppressMovable: true,
        lockPosition: true,
        pinned: 'right',
        filter: false,
        cellRenderer: (params) => {
          const record = params.data;
          return (
            <div>
              <Tooltip title="Edit">
                <EditOutlined
                  className="txtIcon"
                  style={{ marginLeft: '10px', fontSize: '18px' }}
                  onClick={() => showAddEditListModal(record, true)}
                />
              </Tooltip>
              <Tooltip title="Delete">
                <DeleteOutlined
                  className="txtIcon"
                  style={{ marginLeft: '10px', fontSize: '18px' }}
                  onClick={() => handleDeletion(record)}
                />
              </Tooltip>
            </div>
          );
        },
      },
    ];

    setColumnDefs(columnDefs);
    return columnDefs;
  };
  useEffect(() => {
    generateColumns();
  }, []);

  useEffect(() => {
    onFetchEmployeesList();
  }, []);
  //
  useEffect(() => {
    if (employeeList && employeeList.length) {
      employeeList.map((item, i) => {
        item.sno = i + 1;
      });
      setUploadedData(employeeList);
      setFilteredData(employeeList);
    }
  }, [employeeList]);

  const truncateTableData = (data) => {
    return (
      <Tooltip
        placement="topLeft"
        title={data}
      >
        {data}
      </Tooltip>
    );
  };

  //search employees records
  const onSearchEmployees = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchInput(value);

    const filtered = uploadedData.filter(
      (employee) =>
        employee.employeeName.toLowerCase().includes(value) ||
        employee.personNumber.toLowerCase().includes(value)
    );

    setFilteredData(filtered);
  };

  //Edit employee list data
  const showAddEditListModal = async (record, edit) => {
    let userDt = {};
    if (record !== '') {
      record.startDate = moment(record.startDate);
      record.endDate = moment(record.endDate);
      userForm.setFieldsValue(record);
      setEmployeeId(record.id);
    }
    setIsEdit(edit);
    setFormModalVisible(true);
  };

  //Delete List data
  const handleDeletion = (record) => {
    Modal.confirm({
      className: 'custom-text-clr',
      title: 'Are you sure you want to delete this data?',
      async onOk() {
        try {
          onDeleteEmployee({ id: record.id });
        } catch (error) {
          console.error('Error deleting data:', error);
          message.error('Data delete failed.');
          throw error;
        }
      },
      onCancel() { },
    });
  };
  //
  const fileProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      setDisableFileUpload(false);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      setDisableFileUpload(true);
      return false;
    },
    fileList,
  };

  //handle to add and update employees
  const handleOk = () => {
    let payload = {};
    userForm
      .validateFields()
      .then((data) => {
        const {
          coCd = '',
          personNumber = '',
          costCenter = '',
          employeeName = '',
          startDate,
          endDate,
        } = data;

        if (
          coCd.trim() &&
          personNumber.trim() &&
          costCenter.trim() &&
          employeeName.trim() &&
          startDate &&
          endDate
        ) {
          payload = {
            coCd: coCd.trim(),
            personNumber: personNumber.trim(),
            costCenter: costCenter.trim(),
            employeeName: employeeName.trim(),
            startDate,
            endDate,
          };
          if (isEdit) {
            onUpdateEmployee({ data: { employee: payload }, id: employeeId });
            resetFields();
          } else {
            onAddEmployee(payload);
            resetFields();
          }
        } else {
          notification.warning({
            message: 'Fill all the required fields!',
          });
        }
      })
      .catch((errorInfo) => {
        console.log('Validation Failed:', errorInfo);
      });
  };

  const resetFields = () => {
    setTimeout(() => {
      setFormModalVisible(false);
      userForm.resetFields();
      setFileList([]);
      setDisableFileUpload(false);
      setIsEdit(false);
    }, 1000);
  };
  //read excel file
  const readExcelFile = async (file) => {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: 'array' });
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

    // excel file validation
    const requiredHeaders = [
      'CoCd',
      'PersNo',
      'Cost Ctr',
      'Name of Employee or Applicant',
      'Start Date',
      'End Date',
    ];
    const fileHeaders = json[0];
    const hasAllHeaders = requiredHeaders.every((header) => fileHeaders.includes(header));
    if (!hasAllHeaders) {
      notification.error({
        message: 'Invalid File Structure',
        description: `The uploaded file does not have the required headers: ${requiredHeaders.join(
          ', '
        )}.`,
      });
      return;
    }

    // Ensure no cells are empty
    for (let i = 1; i < json.length; i++) {
      const row = json[i];
      for (let j = 0; j < requiredHeaders.length; j++) {
        if (!row[j] && row[j] !== 0) {
          // Check if the cell is empty or undefined, but allow 0
          notification.error({
            message: 'Invalid File Data',
            description: `The uploaded file has empty cells in row ${i + 1}, column ${fileHeaders[j]
              }. Please ensure all cells are filled.`,
          });
          return;
        }
      }
    }

    // const headers = json[0].map(cleanKey);
    const headers = ['coCd', 'personNumber', 'costCenter', 'employeeName', 'startDate', 'endDate'];
    json.shift();

    const arrayOfObjects = json.map((row) => {
      let obj = {};
      row.forEach((cell, i) => {
        obj[headers[i]] = cell;
      });
      return obj;
    });

    return arrayOfObjects;
  };
  //
  const handleFileUpload = async () => {
    if (fileList.length > 0) {
      const data = await readExcelFile(fileList[0]);
      if (data?.length > 0) {
        const convertedData = data.map((record) => {
          let convertedStartDate;
          let convertedEndDate;

          if (typeof record.startDate === 'number') {
            convertedStartDate = convertExcelDate(record.startDate);
          } else if (typeof record.startDate === 'string') {
            convertedStartDate = moment(record.startDate, 'DD-MM-YYYY').toDate();
          }

          if (typeof record.endDate === 'number') {
            convertedEndDate = convertExcelDate(record.endDate);
          } else if (typeof record.endDate === 'string') {
            convertedEndDate = moment(record.endDate, 'DD-MM-YYYY').toDate();
          }
          return {
            ...record,
            startDate: convertedStartDate,
            endDate: convertedEndDate,
          };
        });

        await onUploadBulkEmployeeList({ data: convertedData });
        setTimeout(() => {
          setFileModalVisible(false);
          setFileList([]);
          setDisableFileUpload(false);
        }, 1000);
      }
    } else {
      notification.warn({ message: 'Please select a file to upload.' });
    }
  };

  const handleDownloadExcel = () => {
    const workbook = XLSX.utils.book_new();

    // Define the headers and their corresponding keys in uploadedData
    const headers = [
      { header: 'CoCd', key: 'coCd' },
      { header: 'PersNo', key: 'personNumber' },
      { header: 'Cost Ctr', key: 'costCenter' },
      { header: 'Name of Employee or Applicant', key: 'employeeName' },
      { header: 'Start Date', key: 'startDate' },
      { header: 'End Date', key: 'endDate' },
    ];

    // Add headers to the worksheet data
    const worksheetData = [headers.map((h) => h.header)];

    // Add data rows to the worksheet data
    uploadedData.forEach((dataRow) => {
      const row = headers.map((h) => {
        // Convert dates to a readable format if necessary
        if (h.key === 'startDate' || h.key === 'endDate') {
          return dataRow[h.key] ? moment(dataRow[h.key]).format('DD-MM-YYYY') : '';
        }
        return dataRow[h.key];
      });
      worksheetData.push(row);
    });

    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'EmployeeData');
    // Write the workbook to a binary string
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
    // Convert the binary string to a blob
    const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
    // Trigger the download
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'EmployeeList.xlsx';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };

  // Helper function to convert string to ArrayBuffer
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  const handleCancel = () => {
    setIsEdit(false);
    userForm.resetFields();
    setFormModalVisible(false);
  };
  //
  const modalToImportFile = () => {
    setFileModalVisible(true);
  };
  //
  const handleCancelUploadFile = () => {
    setFileModalVisible(false);
  };
  return (
    <>
      <div className="heat-profile-content-wrapper">
        <div className="heat-profile-card">
          <div className="heat-profile-list-header">
            <div className="heat-profile-header-left">
              <div className="heat-profile-icon-wrap">
                <TeamOutlined style={{ fontSize: 22 }} />
              </div>
              <div className="heat-profile-header-content">
                <div className="heat-profile-title-row">
                  <h3 className="heat-profile-list-title">List of Employees</h3>
                </div>
                <p className="heat-profile-list-description">
                  Manage employees details and cost center assignments.
                </p>
              </div>
            </div>

            <div className="heat-profile-header-actions">
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={handleDownloadExcel}
                className="heat-profile-add-btn"
                style={{ marginRight: '8px', background: '#fff', color: '#111', border: '1px solid #d9d9d9' }}
              >
                Export
              </Button>
              <Button
                type="primary"
                icon={<ImportOutlined />}
                onClick={modalToImportFile}
                className="heat-profile-add-btn"
                style={{ marginRight: '8px', background: '#fff', color: '#111', border: '1px solid #d9d9d9' }}
              >
                Import
              </Button>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => setFormModalVisible(true)}
                className="heat-profile-add-btn"
              >
                Create New
              </Button>
            </div>
          </div>

          <div style={{ marginTop: '16px' }}>
            <Table
              className="h-100 pipeline-table heat-profile-table"
              columns={columns}
              dataSource={filteredData}
              loading={isEmployeeListLoading}
              pagination={{
                current: current,
                pageSize: pageSize,
                total: filteredData.length,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: (page, size) => {
                  setCurrent(page);
                  setPageSize(size);
                },
              }}
              rowKey="id"
            />
          </div>
        </div>
      </div>

      <Modal
        width={800}
        className="materials-modal-modern heatprofile-modal pipeline-modal"
        title={isEdit ? 'Update Employee' : 'Add New Employee'}
        style={{ top: 100 }}
        visible={formModalVisible}
        onCancel={handleCancel}
        footer={[
          <CrcButton
            key="cancel"
            label="Cancel"
            onClick={handleCancel}
            variant="tertiary"
            size="medium"
          />,
          <CrcButton
            key="submit"
            label={isEdit ? (isEmployeeListLoading ? 'Updating' : 'Update') : (isEmployeeListLoading ? 'Creating' : 'Create')}
            onClick={handleOk}
            disabled={isEmployeeListLoading}
            variant="primary"
            size="medium"
          />,
        ]}
      >
        <Form
          name="basic"
          layout="vertical"
          autoComplete="off"
          getcontainer={false}
          form={userForm}
        >
          <Row
            gutter={12}
          >
            <Col lg={8}>
              <Form.Item
                label="CoCd"
                name="coCd"
                required
              >
                <Input
                  placeholder="Enter CoCd"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item
                label="PersNo"
                name="personNumber"
                required
              >
                <Input
                  placeholder="Enter PersNo"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item
                label="Cost Ctr"
                name="costCenter"
                required
              >
                <Input
                  placeholder="Enter Cost Ctr"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item
                label="Name of Employee"
                name="employeeName"
                required
              >
                <Input
                  placeholder="Enter Name of Employee"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item
                label="Start Date"
                name="startDate"
                className="date-picker"
                required
              >
                <DatePicker
                  style={{ width: '100%' }}
                  size="large"
                  format="DD-MM-YYYY"
                />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item
                label="End Date"
                name="endDate"
                className="date-picker"
                required
              >
                <DatePicker
                  style={{ width: '100%' }}
                  size="large"
                  format="DD-MM-YYYY"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        className="materials-modal-modern heatprofile-modal pipeline-modal"
        title="Upload Employees Data"
        style={{ top: 100 }}
        visible={fileModalVisible}
        onCancel={handleCancelUploadFile}
        footer={[
          <CrcButton
            key="cancel"
            label="Cancel"
            onClick={handleCancelUploadFile}
            variant="tertiary"
            size="medium"
          />,
          <CrcButton
            key="apply"
            label={isEmployeeListLoading ? 'Uploading' : 'Upload'}
            onClick={handleFileUpload}
            disabled={isEmployeeListLoading}
            variant="primary"
            size="medium"
          />,
        ]}
      >
        <Form layout="vertical">
          <Row gutter={24}>
            <Col lg={24}>
              <Form.Item label="Upload Excel File">
                <Upload
                  {...fileProps}
                  maxCount={1}
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  className="calibration-upload-input-style"
                >
                  <div className="calibration-upload-trigger">
                    <CloudUploadOutlined className="calibration-upload-icon" />
                    <span>Select File</span>
                  </div>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

const mapStateToProps = ({ employeesReducer }) => {
  const employeeList = get(employeesReducer, 'employeesList', []);
  const isEmployeeListLoading = get(employeesReducer, 'isEmployeesListLoading', []);
  return {
    employeeList,
    isEmployeeListLoading,
  };
};

const mapDispatchToProps = {
  onFetchEmployeesList: fetchEmployeesList,
  onAddEmployee: addEmployee,
  onUploadBulkEmployeeList: uploadBulkEmployeeList,
  onUpdateEmployee: updateEmployee,
  onDeleteEmployee: deleteEmployee,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminEmployees);
